export const FETCH_TOPICS = 'FETCH_TOPICS';
export interface FetchTopicsAction {
    type: typeof FETCH_TOPICS;
}

export const FETCH_TOPICS_SUCCEEDED = 'FETCH_TOPICS_SUCCEEDED';
export interface FetchTopicsSucceededAction {
    type: typeof FETCH_TOPICS_SUCCEEDED;
    topics: Topics;
}

export const FETCH_TOPICS_FAILED = 'FETCH_TOPICS_FAILED';
export interface FetchTopicsFailedAction {
    type: typeof FETCH_TOPICS_FAILED;
    errorMessage: string;
}

export const CREATE_TOPIC = 'CREATE_TOPIC';
export interface CreateTopicAction {
    type: typeof CREATE_TOPIC;
    topic: Topic;
}

export const CREATE_TOPIC_SUCCEEDED = 'CREATE_TOPIC_SUCCEEDED';
export interface CreateTopicSucceededAction {
    type: typeof CREATE_TOPIC_SUCCEEDED;
    topic: Topic;
}

export const CREATE_TOPIC_FAILED = 'CREATE_TOPIC_FAILED';
export interface CreateTopicFailedAction {
    type: typeof CREATE_TOPIC_FAILED;
    errorMessage: string;
}

export const UPDATE_TOPIC = 'UPDATE_TOPIC';
export interface UpdateTopicAction {
    type: typeof UPDATE_TOPIC;
    topic: Topic;
}

export const UPDATE_TOPIC_SUCCEEDED = 'UPDATE_TOPIC_SUCCEEDED';
export interface UpdateTopicSucceededAction {
    type: typeof UPDATE_TOPIC_SUCCEEDED;
    topic: Topic;
}

export const UPDATE_TOPIC_FAILED = 'UPDATE_TOPIC_FAILED';
export interface UpdateTopicFailedAction {
    type: typeof UPDATE_TOPIC_FAILED;
    errorMessage: string;
}

export const DELETE_TOPIC = 'DELETE_TOPIC';
export interface DeleteTopicAction {
    type: typeof DELETE_TOPIC;
    topic: Topic;
}

export const DELETE_TOPIC_SUCCEEDED = 'DELETE_TOPIC_SUCCEEDED';
export interface DeleteTopicSucceededAction {
    type: typeof DELETE_TOPIC_SUCCEEDED;
    topicId: number;
}

export const DELETE_TOPIC_FAILED = 'DELETE_TOPIC_FAILED';
export interface DeleteTopicFailedAction {
    type: typeof DELETE_TOPIC_FAILED;
    errorMessage: string;
}

export const FETCH_SYNONYMS = 'FETCH_SYNONYMS';
export interface FetchSynonymsAction {
    type: typeof FETCH_SYNONYMS;
}

export const FETCH_SYNONYMS_SUCCEEDED = 'FETCH_SYNONYMS_SUCCEEDED';
export interface FetchSynonymsSucceededAction {
    type: typeof FETCH_SYNONYMS_SUCCEEDED;
    synonyms: string[];
}

export const FETCH_SYNONYMS_FAILED = 'FETCH_SYNONYMS_FAILED';
export interface FetchSynonymsFailedAction {
    type: typeof FETCH_SYNONYMS_FAILED;
    errorMessage: string;
}

export const FETCH_ANTONYMS = 'FETCH_ANTONYMS';
export interface FetchAntonymsAction {
    type: typeof FETCH_ANTONYMS;
}

export const FETCH_ANTONYMS_SUCCEEDED = 'FETCH_ANTONYMS_SUCCEEDED';
export interface FetchAntonymsSucceededAction {
    type: typeof FETCH_ANTONYMS_SUCCEEDED;
    antonyms: string[];
}

export const FETCH_ANTONYMS_FAILED = 'FETCH_ANTONYMS_FAILED';
export interface FetchAntonymsFailedAction {
    type: typeof FETCH_ANTONYMS_FAILED;
    errorMessage: string;
}

export const POLL_SYNCSTATUS = 'POLL_SYNCSTATUS';
export interface PollSyncStatusAction {
    type: typeof POLL_SYNCSTATUS;
}

export const POLL_SYNCSTATUS_SUCCEEDED = 'POLL_SYNCSTATUS_SUCCEEDED';
export interface PollSyncStatusSucceededAction {
    type: typeof POLL_SYNCSTATUS_SUCCEEDED;
    syncState: TopicSyncState;
}

export const POLL_SYNCSTATUS_FAILED = 'POLL_SYNCSTATUS_FAILED';
export interface PollSyncStatusFailedAction {
    type: typeof POLL_SYNCSTATUS_FAILED;
    errorMessage: string;
}

export const SYNC_TOPICS = 'SYNC_TOPICS';
export interface SyncTopicsAction {
    type: typeof SYNC_TOPICS;
}

export const SYNC_TOPICS_SUCCEEDED = 'SYNC_TOPICS_SUCCEEDED';
export interface SyncTopicsSucceededAction {
    type: typeof SYNC_TOPICS_SUCCEEDED;
    requestState: TopicSyncRequestState
}

export const SYNC_TOPICS_FAILED = 'SYNC_TOPICS_FAILED';
export interface SyncTopicsFailedAction {
    type: typeof SYNC_TOPICS_FAILED;
    errorMessage: string;
}

export const CREATE_SYNONYM = 'CREATE_SYNONYM';
export interface CreateSynonymAction {
    type: typeof CREATE_SYNONYM;
    synonym: string;
}

export const CREATE_SYNONYM_SUCCEEDED = 'CREATE_SYNONYM_SUCCEEDED';
export interface CreateSynonymSucceededAction {
    type: typeof CREATE_SYNONYM_SUCCEEDED;
    synonym: string;
}

export const CREATE_SYNONYM_FAILED = 'CREATE_SYNONYM_FAILED';
export interface CreateSynonymFailedAction {
    type: typeof CREATE_SYNONYM_FAILED;
    errorMessage: string;
}

export const CREATE_ANTONYM = 'CREATE_ANTONYM';
export interface CreateAntonymAction {
    type: typeof CREATE_ANTONYM;
    antonym: string;
}

export const CREATE_ANTONYM_SUCCEEDED = 'CREATE_ANTONYM_SUCCEEDED';
export interface CreateAntonymSucceededAction {
    type: typeof CREATE_ANTONYM_SUCCEEDED;
    antonym: string;
}

export const CREATE_ANTONYM_FAILED = 'CREATE_ANTONYM_FAILED';
export interface CreateAntonymFailedAction {
    type: typeof CREATE_ANTONYM_FAILED;
    errorMessage: string;
}

export type TopicsActionTypes = FetchTopicsAction | FetchTopicsSucceededAction | FetchTopicsFailedAction |
                                CreateTopicAction | CreateTopicSucceededAction | CreateTopicFailedAction |
                                UpdateTopicAction | UpdateTopicSucceededAction | UpdateTopicFailedAction |
                                DeleteTopicAction | DeleteTopicSucceededAction | DeleteTopicFailedAction |
                                FetchSynonymsAction | FetchSynonymsSucceededAction | FetchSynonymsFailedAction |
                                FetchAntonymsAction | FetchAntonymsSucceededAction | FetchAntonymsFailedAction |
                                PollSyncStatusAction | PollSyncStatusSucceededAction | PollSyncStatusFailedAction |
                                SyncTopicsAction | SyncTopicsSucceededAction | SyncTopicsFailedAction |
                                CreateSynonymAction | CreateSynonymSucceededAction | CreateSynonymFailedAction |
                                CreateAntonymAction | CreateAntonymSucceededAction | CreateAntonymFailedAction;

export class TopicState {
  constructor(
        public topics: Topics,
        public isSaveSuccess: boolean | null,
        public isDeleteSuccess: boolean | null,
        public createdTopicId: number | null,
  ) {}
}

export interface Topics extends Array<Topic> { }

export class Topic {
  constructor(
        public topicId: number,
        public isActive: boolean,
        public name: string,
        public definition: string,
        public comments: string,
        public experienceScore: number,
        public incidentScore: number,
        public operationScore: number,
        public operationSummaryScore: number,
        public sectionSummaryScore: number,
        public dailyReportScore: number,
        public synonyms: string[],
        public antonyms: string[],
  ) {
  }
}

export class TopicSyncState {
  constructor(
    public isReady: boolean | null,
    public hasChange: boolean | null,
  ) {}
}

export class TopicSyncRequestState {
  constructor(
    public isRequested: boolean | null,
    public isCrossEnvironmentSyncEnabled: boolean | null,
  ) {}
}

export class TermCreateState {
  constructor(
    public isCreateSuccess: boolean | null,
    public term: string,
  ) {}
}

export class Term {
  constructor(
    public term: string,
  ) {}
}
